import api from '../api';

export const findDeviceByTopic = (topic, devices) => {
  const { lights = [], conditioner = [], sensors = [] } = devices;
  const allDevices = [...lights, ...conditioner, ...sensors];

  const foundDevice = allDevices.find((device) => {
    if (device?.capabilities) {
      return device.capabilities.some((capability) => {
        if (capability?.address) {
          if (Array.isArray(capability.address)) {
            return capability.address.includes(topic);
          }
          return capability.address === topic;
        }
        return false;
      });
    }
    return false;
  });

  if (foundDevice) {
    const foundCapability = foundDevice.capabilities.find((capability) => {
      if (capability?.address) {
        if (Array.isArray(capability.address)) {
          return capability.address.includes(topic);
        }
        return capability.address === topic;
      }
      return false;
    });

    return {
      deviceId: foundDevice.id,
      deviceName: foundDevice.name,
      deviceType: foundDevice.type,
      capabilityId: foundCapability?.id,
      capabilityName: foundCapability?.name || foundCapability?.title,
    };
  }

  return null;
};

export const sendMqttLog = async (message, roomData, devices) => {
  try {
    let deviceInfo = null;
    if (message.topic) {
      deviceInfo = findDeviceByTopic(message.topic, devices);
    }

    const logMessage = {
      ...message,
      roomTitle: roomData?.title || 'Unknown Room',
      roomType: roomData?.type || 'Unknown RoomType',
      ...(deviceInfo && {
        deviceId: deviceInfo.deviceId,
        deviceName: deviceInfo.deviceName,
        deviceType: deviceInfo.deviceType,
        capabilityId: deviceInfo.capabilityId,
        capabilityName: deviceInfo.capabilityName,
      }),
    };

    await api.sendMqttLog(logMessage);
  } catch (error) {
    console.error('Failed to send MQTT log:', error);
  }
};

export const createMqttLogMessage = (address, value, qos = 0, isScenario = false, type = 'sent') => ({
  type,
  topic: address,
  payload: value.toString(),
  qos,
  isScenario,
  timestamp: new Date().toISOString(),
});
